import { TReduxActions } from '../../../types/redux';
import { EOpenNewReviewForm } from '../../../actions/newReview';

export const defaultValue = false;

export function openReducer(state: boolean = defaultValue, { type }: TReduxActions): boolean {
  if (type === EOpenNewReviewForm.Open) {
    return true;
  }

  if (type === EOpenNewReviewForm.Close) {
    return false;
  }

  return state;
}
